export default "__VITE_ASSET__CZyHg$5d__"